import './DefaultInfoBubble.css'

export type DefaultInfoBubbleProps = {
  companyName: string
  city: string
  zipCode: string
  street: string
  houseNumber: string
  mobilePhoneNumber?: string
  mobilePhoneNumberLabel?: string
  addressLabel?: string
  buttonLabel?: string
}

export const createBubble = ({
  addressLabel,
  city,
  companyName,
  mobilePhoneNumber,
  mobilePhoneNumberLabel,
  street,
  houseNumber,
  zipCode,
  buttonLabel,
}: DefaultInfoBubbleProps): string => {
  const mobileContainer = mobilePhoneNumber
    ? `<p><strong>${mobilePhoneNumberLabel}:</strong> <a href="tel:${mobilePhoneNumber}">${mobilePhoneNumber}</a></p>`
    : ''
  return `
  <div class="sf-hmap-bubble-container">
    <h2 class="sf-hmap-bubble-companyName">${companyName}</h2>
    <p><strong>${addressLabel}: </strong><span>${street} ${houseNumber}, ${zipCode} ${city}</span></p>
    ${mobileContainer}
    <button type="button" title="${buttonLabel}" class="c-btn c-btn__text">${buttonLabel}</button>
  </div>`
}
